"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteBucketPolicyInput = {
    type: "structure",
    required: ["Bucket"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        }
    }
};
//# sourceMappingURL=DeleteBucketPolicyInput.js.map